import * as THREE from "three";
import { BaseDataType } from "../../../base-data-type";

export class ThreedLandmarkComponent {
    
    public readonly TAG: string = "[ThreedLandmarkComponent]";
    
    public id: string;
    public type: BaseDataType;
    
    public scene: THREE.Scene;
    public sprite: THREE.Sprite;
    public size: number;
    private canvasSize: number;
    private bgColor: string;
    
    private _lang: string;
    
    private _context: CanvasRenderingContext2D;
    
    private _centerX: number;
    private _centerY: number;
    private _radius: number;

    /**
     * Add a landmark in the 3d view scene.
     *
     * @param pType {BaseDataType}
     * @param pScene {THREE.Scene}
     * @param pCanvasSize {number}  label creation canvas size/definition in pixels (256*256px)
     */
    constructor(pType: BaseDataType, pLang: string, pScene: THREE.Scene, pSize: number, pCanvasSize: number = 256, pLandmarkBgColor: string = "#e2202b") {
        this.type = pType;
        this.id = this.type.id;
        this.scene = pScene;
        this.size = pSize;
        this.canvasSize = pCanvasSize;
        this.bgColor = pLandmarkBgColor;

        this._lang = pLang;

        const canvas: HTMLCanvasElement = document.createElement("canvas");
        canvas.width = this.canvasSize;
        canvas.height = this.canvasSize;

        this._context = canvas.getContext("2d");

        this._centerX = this.canvasSize / 2;
        this._centerY = this._centerX;
        this._radius = this._centerX - 5;

        this._updateCanvas();

        const amap: THREE.Texture = new THREE.Texture(canvas);
        amap.needsUpdate = true;

        const mat: THREE.SpriteMaterial = new THREE.SpriteMaterial({
            map: amap,
            transparent: false,
            color: 0xffffff
        });

        this.sprite = new THREE.Sprite(mat);

        const bounds: THREE.Box3 = new THREE.Box3().setFromObject(this.sprite);

        const width = bounds.max.x - bounds.min.x;
        const height = bounds.max.y - bounds.min.y;
        const depth = bounds.max.z - bounds.min.z;

        /*console.log(width, height, depth);
        console.log(Math.max(width, height, depth));
        console.log(pSize);*/

        this.sprite.scale.set(this.size, this.size, 1);
        this.sprite.name = this.id;
        this.scene.add(this.sprite);
    }

    public updateLang(pLang: string) {
        if (this._lang === pLang) { return; }

        if (this.type.label[pLang] === this.type.label[this._lang]) { return; }

        console.log(this.TAG, "updateLang()", pLang);

        this._lang = pLang;

        this._updateCanvas();
    }

    private _updateCanvas(): void {
        const label = this.type.label[this._lang];
        if (label !== undefined) {
            this._context.clearRect(0, 0, this.canvasSize, this.canvasSize);

            this._context.beginPath();
            this._context.arc(this._centerX, this._centerY, this._radius, 0, 2 * Math.PI, false);
            this._context.fillStyle = this.bgColor;
            this._context.fill();

            // this._context.lineWidth = 10;
            // this._context.strokeStyle = "#FF0000";
            // this._context.stroke();

            this._context.fillStyle = "#ffffff";
            this._context.textAlign = "center";
            this._context.font = "120px Arial";
            this._context.fillText(label, this._centerX, this._centerY + 40);

            // Update texture material
            if (this.sprite) { this.sprite.material.map.needsUpdate = true; }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/building-customization/threed-view/threed-landmark.component.ts